export default __webpack_public_path__ + "static/media/PDF.6b3504ef.svg";